<template>
  <div>
    <h5>{{ courseId ? 'Edit Kursus' : 'Tambah Kursus' }}</h5>
    <div class="row">
      <div class="col-md-8 mb-2">
        <label>Judul Kursus *</label>
        <input v-model="form.title" class="form-control" required>
      </div>
      <div class="col-md-4 mb-2">
        <label>Slug URL</label>
        <input v-model="form.slug" class="form-control" placeholder="auto dari judul">
      </div>
      <div class="col-md-12 mb-2">
        <label>Deskripsi</label>
        <textarea v-model="form.description" class="form-control" rows="3"></textarea>
      </div>
      <div class="col-md-6 mb-2">
        <label>Cover Image URL</label>
        <input v-model="form.cover_image_url" class="form-control" placeholder="https://...">
      </div>
      <div class="col-md-3 mb-2">
        <label>Harga (Rp, 0 = gratis)</label>
        <input v-model.number="form.price" type="number" min="0" class="form-control">
      </div>
      <div class="col-md-3 mb-2">
        <label>Status</label>
        <select v-model="form.status" class="form-control">
          <option value="active">Aktif</option>
          <option value="inactive">Nonaktif</option>
        </select>
      </div>
    </div>

    <hr>
    <ModuleLessonEditor v-model="form.modules" />

    <div class="text-right mt-3">
      <button class="btn btn-secondary mr-2" @click="$emit('close')">Batal</button>
      <button class="btn btn-primary" @click="save" :disabled="saving">
        <span v-if="saving" class="spinner-border spinner-border-sm mr-1"></span>
        Simpan Kursus
      </button>
    </div>
  </div>
</template>

<script>
import ModuleLessonEditor from './ModuleLessonEditor.vue';

export default {
  name: 'CourseForm',
  components: { ModuleLessonEditor },
  props: {
    shopId: { type: Number, required: true },
    courseId: { type: Number, default: null },
  },
  data() {
    return {
      saving: false,
      form: {
        title: '', slug: '', description: '', cover_image_url: '',
        price: 0, status: 'active', modules: [],
      },
    };
  },
  mounted() {
    if (this.courseId) this.load();
    else this.form.modules = [{ title: 'Modul 1', lessons: [{ title: 'Pelajaran 1', content_type: 'text', content: '', is_preview: false }] }];
  },
  methods: {
    async load() {
      try {
        const r = await this.$store.dispatch('shop_lms/lms_get_course', this.courseId);
        const c = r.data.data.course || {};
        this.form = {
          title: c.title || '',
          slug: c.slug || '',
          description: c.description || '',
          cover_image_url: c.cover_image_url || '',
          price: c.price || 0,
          status: c.status || 'active',
          modules: (c.modules || []).map(m => ({
            title: m.title,
            lessons: (m.lessons || []).map(l => ({
              title: l.title,
              content_type: l.content_type || 'text',
              content: l.content || '',
              video_url: l.video_url || '',
              duration_minutes: l.duration_minutes || 0,
              is_preview: l.is_preview === 1,
            })),
          })),
        };
      } catch (e) {
        this.$toast.error('Gagal memuat kursus');
      }
    },
    async save() {
      if (!this.form.title) {
        this.$toast.error('Judul kursus wajib diisi');
        return;
      }
      this.saving = true;
      try {
        const payload = { ...this.form };
        if (this.courseId) {
          await this.$store.dispatch('shop_lms/lms_update_course', { id: this.courseId, course: payload });
        } else {
          await this.$store.dispatch('shop_lms/lms_create_course', { shopId: this.shopId, course: payload });
        }
        this.$toast.success('Kursus disimpan');
        this.$emit('saved');
        this.$emit('close');
      } catch (e) {
        this.$toast.error(e.response?.data?.message || 'Gagal menyimpan');
      } finally { this.saving = false; }
    },
  },
};
</script>
